import { broadcast, broadcastChannels } from '@common/helpers/broadcast';

// TODO, TitoOperationResult will be called just one time and all tickets results will be in it, and then we can remove the count logic below
export const getBulkOperationResult = (ticketsLength) => new Promise((resolve) => {
  const ticketsResponse = [];
  const onResponse = (e) => {
    ticketsResponse.push(e.detail);

    if (ticketsResponse.length === ticketsLength) {
      resolve(ticketsResponse);
      // TODO: Remove listener from TitoOperationResult
    }
  };

  broadcast.addEventListener(broadcastChannels.TitoOperationResult, onResponse);
});
